




















































































import { readActionLogsResponse } from '@/store/main/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { dispatchGetUserActionLogs } from '@/store/main/actions';

@Component({
  components: {
    FmvAvatar,
  },
})
export default class ActionLogsTable extends Vue {
  // @ts-ignore
  @Prop({required: true}) readonly public userId: number;
  // @ts-ignore
  @Prop({required: false, default: ''}) readonly public className: string;
  public currentPage = 1;
  public perPage = 6;
  public loadingState = {
    list: false,
  };

  public async mounted() {
    this.loadingState.list = true;
    await dispatchGetUserActionLogs(
      this.$store, {rowQuery: `?page=${this.currentPage}&page_size=${this.perPage}`, data: {user_id: this.userId}},
    );
    this.loadingState.list = false;
  }

  get logsList() {
    return readActionLogsResponse(this.$store);
  }

  public async handleChangePage(page) {
    this.loadingState.list = true;
    this.currentPage = page;
    await dispatchGetUserActionLogs(
      this.$store, {rowQuery: `?page=${this.currentPage}&page_size=${this.perPage}`, data: {user_id: this.userId}},
    );
    this.loadingState.list = false;
  }

  get logsFields() {
    return [
      {
        key: 'action',
        label: this.$t('Action'),
        sortable: false,
      },
      {
        key: 'created_at',
        label: this.$t('Created at'),
        sortable: false,
      },
    ];
  }

}
